import React, { useState, useRef, useReducer } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { Modal } from '@material-ui/core'
import { useStyles } from '../MaterialUiModal'
import WorkflowListBase from './Workflow/WorkflowList'
import Workflow from './Workflow'
import BootstrapAlert from '../element/BootstrapAlert'
import ErrorBoundary from '../ErrorBoundary'

const getSelectionState = (selectedId, workflowMap, userMap) => {
  if (selectedId) {
    const workflow = workflowMap.get(selectedId)
    const approvers = workflow.approvers
    const levelMap = approvers
      .reduce((m, current, i, src) => {
        if (!m.has(current.level)) {
          m.set(current.level, [])
        }
        m.get(current.level).push(userMap.get(current.sp_user_id))
        return m
      }, new Map())
    return {
      id: selectedId,
      workflow: workflow,
      members: Array.from(levelMap.keys()).sort().map((key) => levelMap.get(key))
    }
  } else {
    return {
      id: null,
      workflow: null,
      members: []
    }
  }
}

const selectionStateReducer = (workflowMap, userMap) => (state, selectedId) => {
  if (state.id === selectedId) {
    return state
  }
  return getSelectionState(selectedId, workflowMap, userMap)
}

export default function WorkflowList (props) {
  const classes = useStyles()
  const workflowMapRef = useRef(
    new Map(props.workflows.map((wf) => [wf.id, wf]))
  )
  const userMapRef = useRef(
    new Map(props.generalUsers.map((user) => [user.id, user]).concat(props.managers.map((user) => [user.id, user])))
  )
  const [selectionState, selectionStateDispatcher] = useReducer(
    selectionStateReducer(workflowMapRef.current, userMapRef.current),
    getSelectionState(props.workflows.length > 0 ? props.workflows[0].id : null, workflowMapRef.current, userMapRef.current)
  )
  const [deleteModalOpen, setDeleteModalOpen] = useState(false)
  const csrfRef = useRef($('meta[name="csrf-token"]'))

  return (
    <>
      <div className="row">
        <div className="col-4 text-center">
          {
            Workflow(
              props.generalUsers,
              props.managers,
              selectionState.members,
              'ルート設定者',
              true,
              true,
              selectionState.workflow?.name ?? '承認ルートが登録されていません。'
            )
          }
        </div>
        <div className="col-8 d-flex flex-column align-items-end">
          { WorkflowListBase(props.workflows, selectionStateDispatcher) }
          {selectionState.id && (
            <>
              <button type='button' className='btn btn-danger flex-shrink-1 my-3' onClick={() => setDeleteModalOpen(true)}>削除</button>
              <Modal
                className={classes.modal}
                open={deleteModalOpen}
                onClose={() => setDeleteModalOpen(false)}>
                <div className={classes.paper}>
                  <h2>承認ルートテンプレート削除</h2>
                  <hr />
                  <p>承認ルートテンプレート {selectionState.workflow?.name ?? ''} を削除しますか？</p>
                  <BootstrapAlert class="danger">
                    <div>削除した承認ルートは復元できません。</div>
                  </BootstrapAlert>
                  <hr />
                  <div className="row">
                    <div className="col-6">
                      <button type='button' className='btn btn-outline-secondary' onClick={() => setDeleteModalOpen(false)}>キャンセル</button>
                    </div>
                    <div className="col-6 text-right">
                      <form action={selectionState.workflow?.delete_url ?? ''} method="post">
                        <input type="text" name="_token" className="d-none" value={csrfRef.current.attr('content')} readOnly />
                        <button type='submit' className='btn btn-danger'>削除</button>
                      </form>
                    </div>
                  </div>
                </div>
              </Modal>
            </>
          )}
        </div>
      </div>
    </>
  )
}

WorkflowList.propTypes = {
  postUrl: PropTypes.string,
  generalUsers: PropTypes.arrayOf(PropTypes.object),
  managers: PropTypes.arrayOf(PropTypes.object),
  workflows: PropTypes.arrayOf(PropTypes.object)
}

$('#workflow-list').each((i, el) => {
  const qel = $(el)
  const props = qel.data() // bladeでdata-xxxx形式で指定した値がpropsとして参照できる
  ReactDOM.render(
    <ErrorBoundary>
      <WorkflowList {...props}/>
    </ErrorBoundary>,
    el
  )

  Object.keys(props).map((key) => { // ソースにdata-属性が残らないように削除
    qel.removeAttr('data-' + key.replace(/[A-Z]/g, (s) => '-' + s.charAt(0).toLowerCase()))
    return 0
  })
})
